<template>
  <ul class="c-menu c-menu--dark" v-if="user">
    <template v-for="type in Object.keys(menu)" v-if="menu[type].length">
      <li class="c-menu__category">{{ $t(`${type}.label`).toUpperCase() }}</li>

      <menu-sidebar-item v-for="action in menu[type]" :key="action.label" :item="action" :type="type" :level="1" />

      <li class="c-menu__divider"></li>
    </template>
  </ul>
</template>

<script>
  import { mapFields } from 'vuex-map-fields'
  import { mapGetters } from 'vuex'
  import breadcrumb from '@/storage/breadcrumb'
  import { cloneDeep } from 'lodash'
  import MenuSidebarItem from '@/components/template/MenuSidebarItem'

  export default {
    mounted () {
      if (document.querySelector('.router-link-active.is-active') !== null) {
        const element = document.querySelector('.router-link-active.is-active').closest('.has-sub')
        if (element) {
          element.classList.add('is-open')
        }
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionMarketplacesInstalled',
        'definitionEcommerceInstalled',
        'definitionErpInstalled',
        'definitionToolsInstalled',
        'definitionShipmentsInstalled'
      ]),
      ...mapFields({
        user: 'user.user'
      }),
      menu () {
        const data = cloneDeep(breadcrumb)

        const menu = {
          general: [],
          marketplace: [],
          ecommerce: [],
          erp: [],
          tool: [],
          shipment: []
        }

        menu.general.push({
          label: 'Dashboard',
          path: '/',
          hasLink: true,
          hasMenu: true,
          iconMenu: 'icon-pie-chart'
        })

        for (let i in data[0].children) {
          const item = data[0].children[i]

          switch (item.path) {
            case 'marketplace':
              for (let j in item.children) {
                const module = item.children[j]
                const moduleDefinition = this.definitionMarketplacesInstalled.find(moduleInstalled => moduleInstalled.identifier === module.path)
                if (!moduleDefinition) {
                  continue
                }
                module.inactive = !moduleDefinition.module.status
                menu.marketplace.push(module)
              }
              break

            case 'ecommerce':
              for (let j in item.children) {
                const module = item.children[j]
                const moduleDefinition = this.definitionEcommerceInstalled.find(moduleInstalled => moduleInstalled.identifier === module.path)
                if (!moduleDefinition) {
                  continue
                }
                module.inactive = !moduleDefinition.module.status
                menu.ecommerce.push(module)
              }
              break

            case 'erp':
              for (let j in item.children) {
                const module = item.children[j]
                const moduleDefinition = this.definitionErpInstalled.find(moduleInstalled => moduleInstalled.identifier === module.path)
                if (!moduleDefinition) {
                  continue
                }
                module.inactive = !moduleDefinition.module.status
                menu.erp.push(module)
              }
              break

            case 'tool':
              for (let j in item.children) {
                const module = item.children[j]
                const moduleDefinition = this.definitionToolsInstalled.find(moduleInstalled => moduleInstalled.identifier === module.path)
                if (!moduleDefinition) {
                  continue
                }
                module.inactive = !moduleDefinition.module.status
                menu.tool.push(module)
              }
              break

            case 'shipment':
              for (let j in item.children) {
                const module = item.children[j]
                const moduleDefinition = this.definitionShipmentsInstalled.find(moduleInstalled => moduleInstalled.identifier === module.path)
                if (!moduleDefinition) {
                  continue
                }
                module.inactive = !moduleDefinition.module.status
                menu.shipment.push(module)
              }
              break

            default:
              menu.general.push(item)
          }
        }

        return menu
      }
    },
    components: {
      MenuSidebarItem
    }
  }
</script>



// WEBPACK FOOTER //
// MenuSidebar.vue?0905177a